// extracted by css-extract-rspack-plugin
export default {"messageContent":"SignedCommitHeader-module__messageContent__HUHLsw5"};